import sales from "./sales";

const rootStore = {
  sales
};

export default rootStore;
